// extracted by extract-css-chunks-webpack-plugin
module.exports = {"creditBreakdownHeader":"CreditBreakdownHeader-1617515eb7867399","title":"CreditBreakdownHeader-faf5d2ab4088ff05","subtitle":"CreditBreakdownHeader-d4e0e1cdfd6e048a"};